import React from 'react';
import { Modal } from 'rsuite';
import ShoppingCartContent from '../../shopping-cart-content';
import { useWindowSize } from 'react-use';
import { Connection, mapEdgesToItems } from '@/helpers/maps';

export type DraftOrderType = {
  userDraftOrders: {
    lines: any[];
    linesSimilarProducts: Connection<any>;
  }[];
};
export type GuestDraftOrderType = {
  draftOrder: {
    lines: any[];
    linesSimilarProducts: Connection<any>;
  };
};

type ComtentProps = {
  openCartModal: boolean;
  setOpenCartModal: (e: boolean) => void;
  isLoggedIn: boolean;
  draftOrdersData: DraftOrderType | undefined;
  guestDraftOrdersData: GuestDraftOrderType | undefined;
  handleCartClose: () => void;
  id?: string | null | undefined;
};

const ContentModal = ({
  openCartModal,
  setOpenCartModal,
  isLoggedIn,
  draftOrdersData,
  guestDraftOrdersData,
  handleCartClose,
  id,
}: ComtentProps) => {
  const { width } = useWindowSize();
  return (
    <Modal
      role="dialog"
      backdrop={true}
      size="md"
      style={{ zIndex: 4000, marginLeft: 0, marginRight: 0, width: '102%' }}
      open={openCartModal}
      onClose={() => setOpenCartModal(false)}
    >
      <Modal.Dialog style={{ maxWidth: width <= 768 ? '100%' : '740px' }}>
        <ShoppingCartContent
          orderLine={(isLoggedIn
            ? draftOrdersData?.userDraftOrders?.[0]?.lines
            : guestDraftOrdersData?.draftOrder?.lines
          )?.find((line: any) => line?.productVariantId === id)}
          similarProducts={mapEdgesToItems(
            (isLoggedIn
              ? draftOrdersData?.userDraftOrders?.[0]?.linesSimilarProducts
              : guestDraftOrdersData?.draftOrder
                  ?.linesSimilarProducts) as Connection<any>
          )}
          handleCartClose={handleCartClose}
        />
      </Modal.Dialog>
    </Modal>
  );
};

export default ContentModal;
